import React from 'react';

const Toolbar = props => (
    <caption class="table-toolbar">{props.children}</caption>
);

export default Toolbar;
